import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_BLOG_COMPONENT_IMAGE_WITH_COPY_CONFIG } from './cms-blog-component-image-with-copy.config';
import { NCmsBlogComponentImageWithCopy } from './cms-blog-component-image-with-copy.interface';

@Component({
    selector: 'image-with-copy',
    templateUrl: './cms-blog-component-image-with-copy.component.html',
    standalone: true,
    imports: [DfImageDirective, HrefComponent, ICmsClientModule, NgClass, SizeClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsBlogComponentImageWithCopyComponent>(CMS_BLOG_COMPONENT_IMAGE_WITH_COPY_CONFIG)
export class CmsBlogComponentImageWithCopyComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    @Input()
    component!: NCmsBlogComponentImageWithCopy.IData;
}
